<template>
  <div class="display-flex align-center search">
    <bh-icon icon="search-icon" class="pl1 f1-3" v-if="showIcon" />
    <bh-input
      class="search-input ml1 w100p"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :inputClasses="searchInputClass"
      @output="onSearch"
      />
  </div>
</template>

<script>
export default {
  name: 'bh-search-bar',
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    searchInputClass: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onSearch(input) {
      this.$emit('search', input)
    }
  }
}
</script>

<style scoped>
  .search {
    border-radius: 5px;
    background-color: #f5f6fB;
  }
</style>
